import { RefObject, useCallback } from 'react';
import { useHeaderResizeListener } from 'src/commons/utils/hooks';

// update nav positioning based on header resizing
export default (navRef: RefObject<HTMLDivElement>): void => {
  const callback = useCallback((e: Event) => {
    const customEvent = e as CustomEvent;
    if (navRef.current) {
      navRef.current.style.top = `${customEvent.detail.headerHeight}px`;
    }
  }, []);

  useHeaderResizeListener({ callback });
};
